module.exports = __webpack_public_path__ + "static/media/Settings.4453dd10.png";